/**
 * @generated SignedSource<<bf09a6d7434354e154fa1f18ba47cff8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnClassificationEnum = "CHARGEBACK" | "DIVIDEND" | "FINANCING_FEE" | "FRAUDULENT" | "LOAN_PROCEEDS" | "LOAN_REPAYMENT" | "PROCESSOR_FEE" | "REFUND" | "SALARY" | "TAX_PAYMENT" | "TAX_REFUND" | "%future added value";
export type TxnSortEnum = "ACCOUNT" | "AMOUNT" | "CATEGORY" | "COUNTERPARTY" | "DATE" | "DESCRIPTION" | "NATURE" | "%future added value";
export type needsReviewPage_Query$variables = {
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  perspectiveId?: string | null | undefined;
  sort?: TxnSortEnum | null | undefined;
  sortDirection?: string | null | undefined;
};
export type needsReviewPage_Query$data = {
  readonly allStakeholders: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly last4: string | null | undefined;
    readonly name: string;
    readonly nickname: string;
    readonly number: string;
  }>;
  readonly transactions: {
    readonly totalCount: number;
    readonly txns: ReadonlyArray<{
      readonly accountNumber: string | null | undefined;
      readonly amount: number;
      readonly category: string | null | undefined;
      readonly classification: TxnClassificationEnum | null | undefined;
      readonly counterpartCandidateCount: number;
      readonly counterpartCandidates: ReadonlyArray<{
        readonly amount: number;
        readonly bankAccount: {
          readonly last4: string | null | undefined;
          readonly nickname: string;
        };
        readonly postingDate: string;
        readonly txn: {
          readonly id: string;
        };
      }>;
      readonly counterparty: {
        readonly name: string;
      } | null | undefined;
      readonly description: string;
      readonly expenseNature: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
      readonly internal: boolean;
      readonly kind: string;
      readonly md5: string;
      readonly needsReviewManual: boolean;
      readonly postingDate: string;
      readonly txn: {
        readonly id: string;
      };
    }>;
  };
  readonly unprojectedDecisions: ReadonlyArray<{
    readonly decidedBy: string | null | undefined;
    readonly dimension: string;
    readonly id: string;
    readonly txnAmount: number | null | undefined;
    readonly txnDescription: string | null | undefined;
    readonly txnPostingDate: string | null | undefined;
    readonly valueLabel: string | null | undefined;
  }>;
};
export type needsReviewPage_Query = {
  response: needsReviewPage_Query$data;
  variables: needsReviewPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perspectiveId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortDirection"
},
v5 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Literal",
    "name": "needsReview",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "perspectiveId",
    "variableName": "perspectiveId"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  },
  {
    "kind": "Variable",
    "name": "sortDirection",
    "variableName": "sortDirection"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Txn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "md5",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postingDate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "internal",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "needsReviewManual",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = [
  (v7/*: any*/),
  (v19/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseNature",
  "kind": "LinkedField",
  "name": "expenseNature",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "counterpartCandidateCount",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nickname",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "last4",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccounts",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v19/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "number",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "allStakeholders",
  "plural": true,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "UnprojectedDecision",
  "kind": "LinkedField",
  "name": "unprojectedDecisions",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dimension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "valueLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "txnDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "txnPostingDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "txnAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "decidedBy",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "needsReviewPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TxnCounterpartCandidate",
                "kind": "LinkedField",
                "name": "counterpartCandidates",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v12/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BankAccount",
                    "kind": "LinkedField",
                    "name": "bankAccount",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "needsReviewPage_Query",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "TransactionsPage",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionRow",
            "kind": "LinkedField",
            "name": "txns",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Stakeholder",
                "kind": "LinkedField",
                "name": "counterparty",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v22/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TxnCounterpartCandidate",
                "kind": "LinkedField",
                "name": "counterpartCandidates",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v12/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BankAccount",
                    "kind": "LinkedField",
                    "name": "bankAccount",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/)
    ]
  },
  "params": {
    "cacheID": "214c17fe46bbe588142588e353778256",
    "id": null,
    "metadata": {},
    "name": "needsReviewPage_Query",
    "operationKind": "query",
    "text": "query needsReviewPage_Query(\n  $perspectiveId: ID\n  $sort: TxnSortEnum\n  $sortDirection: String\n  $limit: Int\n  $offset: Int\n) {\n  transactions(needsReview: true, perspectiveId: $perspectiveId, sort: $sort, sortDirection: $sortDirection, limit: $limit, offset: $offset) {\n    totalCount\n    txns {\n      txn {\n        id\n      }\n      md5\n      postingDate\n      description\n      amount\n      kind\n      accountNumber\n      internal\n      classification\n      category\n      needsReviewManual\n      expenseNature {\n        id\n        name\n      }\n      counterparty {\n        name\n        id\n      }\n      counterpartCandidateCount\n      counterpartCandidates {\n        txn {\n          id\n        }\n        amount\n        postingDate\n        bankAccount {\n          nickname\n          last4\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  bankAccounts {\n    id\n    name\n    nickname\n    last4\n    number\n  }\n  allStakeholders {\n    id\n    name\n  }\n  unprojectedDecisions {\n    id\n    dimension\n    valueLabel\n    txnDescription\n    txnPostingDate\n    txnAmount\n    decidedBy\n  }\n}\n"
  }
};
})();

(node as any).hash = "1c31614e7aef413bbfcf37ed756fb074";

export default node;
